$(document).ready(function() {
    let countdownInitialized = false;  // Add a flag to track countdown status

    function countdown(elementName, minutes, seconds) {
        console.log('countdown',elementName, minutes, seconds);
        var element, endTime, hours, mins, time;
        
        function twoDigits(n) {
            return n <= 9 ? "0" + n : n;
        }

        function updateTimer() {
            msLeft = endTime - +new Date();
            
            if (window.msLeft < 1000) {
                elementName.innerHTML = "Time is up!";
                countdownInitialized = false;  // Reset the flag once the countdown finishes
            } else {
                time = new Date(window.msLeft);
                hours = time.getUTCHours();
                mins = time.getUTCMinutes();
                
                var newtime = (hours ? hours + ":" + twoDigits(mins) : mins) + ":" + twoDigits(time.getUTCSeconds());
                elementName.innerText = newtime;
                setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
            }
        }

        element = document.getElementById(elementName);
        endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
        updateTimer();
    }

    function countdownInitializedclick(){
      // Initialize countdown only if it hasn't been initialized
      if (!countdownInitialized) {
        // Select all elements with the class 'reserve_counter'
        const counters = document.querySelectorAll(".reserve_counter");
        counters.forEach((counter) => {
          // Get the target time from the 'data-targettime' attribute
          const targetTime = counter.dataset.targettime;
          
          if (targetTime) {
              // Initialize countdown for each counter element
              countdown(counter, targetTime, 0);
          }
        });
        countdownInitialized = true;  // Set the flag to true after initializing countdown
      }
    }
    if(document.querySelectorAll("#CartPageForm").length > 0){
     // console.log('countdownInitializedclick');
      countdownInitializedclick();
    }

    // On click of the "#HeaderCartTrigger" anchor tag
    $('#HeaderCartTrigger').on('click', function(event) {
        event.preventDefault();  // Prevent the default action
        $('.site-cart__drawer').addClass('is-active');  // Add "is-active" class to ".site-cart__drawer"
        countdownInitializedclick();        
    });

    // On click of the "js-close-cart-drawer" element
    $('.js-close-cart-drawer').on('click', function() {
        $('.site-cart__drawer').removeClass('is-active');  // Remove "is-active" class from ".site-cart__drawer"
    });

    $('#CartDrawer-Overlay').on('click', function() {
        $('.site-cart__drawer').removeClass('is-active');  // Remove "is-active" class from ".site-cart__drawer"
    });
});
